const requestNotificationPermission = async () => {
  if (!('Notification' in window)) return false;

  if (Notification.permission === 'granted') return true;

  if (Notification.permission === 'default') {
    Notification.requestPermission().then((permission) => {
      return permission === 'granted';
    });
  }

  return false;
};

export default requestNotificationPermission;
